// Alaska clinics sign logo-free consent forms
// This app only renders the consent links, the templates live in the clinic app
// Keep in step with the clinic app copy of this file

// Clinic codes that get the Alaska files
export const UNBRANDED_CLINICS = [
    'AK01HF', // Huffman
    'AK02AE', // Anchorage East
    'AK03DM', // Dimond
    'AK04AS', // Anchorage South
    'AK05ER', // Eagle River
    'ZZ99ZZ', // test clinic
];

export function isUnbrandedClinic(clinicCode: string | null | undefined): boolean {
    if (!clinicCode) return false;
    return UNBRANDED_CLINICS.includes(clinicCode);
}

// Blob folder for the read-only PDFs the consent checkbox links to
const CONSENT_PDF_BASE = 'https://medformioprodeastus2.blob.core.windows.net/patient-pdf/pdf';

// Blob files with an Alaska copy in pdf/unbrandedPDFs
// Checked per file, the label also links legacy forms that have none
const UNBRANDED_BLOB_PDFS = new Set([
    'Patient Informed Consent v3-2026-01-08.pdf',
    'Payment Agreement and Authorization v3-2026-01-08.pdf',
    'State Biometric Privacy Laws Disclosure and Consent New.pdf',
    'Acknowledgement of Receipt of NOPP v1-2026-01-08.pdf',
    'Notice of Privacy Practices v2-2026-01-08.pdf',
    'Personal Injury Authorization, Assignment, Contractual Lien & Letter of Protection.pdf',
    'Workers Comp (WC) Paperwork 2025.pdf',
]);

// Filenames behind Form.io labels that hardcode a blob link
export const PI_CONSENT_PDF =
    'Personal Injury Authorization, Assignment, Contractual Lien & Letter of Protection.pdf';
export const WC_FORMS_PDF = 'Workers Comp (WC) Paperwork 2025.pdf';

// Alaska copies keep the branded filename
export function unbrandedConsentPdfUrl(clinicCode: string, fileName: string): string {
    const base =
        isUnbrandedClinic(clinicCode) && UNBRANDED_BLOB_PDFS.has(fileName)
            ? `${CONSENT_PDF_BASE}/unbrandedPDFs`
            : CONSENT_PDF_BASE;
    return `${base}/${fileName}`;
}
